module.exports = __webpack_public_path__ + "static/img/stw049.aa0dd62b.png";